import { Phone, MessagesSquare, CalendarCheck, HeartHandshake } from "lucide-react";
import { COMPANY } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  { Icon: Phone, t: "Contact us", d: `Call ${COMPANY.phoneDisplay}, email us, or send a care or staffing request on this page.` },
  { Icon: MessagesSquare, t: "Discuss your needs", d: "We talk through the setting, the kind of support needed and the schedule you have in mind." },
  { Icon: CalendarCheck, t: "Confirm services & availability", d: "We confirm coverage for your location, the services we can provide and caregiver availability." },
  { Icon: HeartHandshake, t: "Begin care", d: "Care or staffing begins on the schedule agreed with you." },
];

export const About = () => (
  <section id="about" className="py-20 sm:py-28 no-print" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <Reveal className="lg:col-span-6 space-y-4">
          <Eyebrow>About Elevion</Eyebrow>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#154F49] leading-[1.02]">Care that is matched, <em className="text-[#9B742A]">not just assigned.</em></h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6 space-y-4 text-[#2C3B37] leading-relaxed">
          <p>{COMPANY.name} is based in Upper Marlboro, Maryland, and serves families and healthcare facilities across Maryland and the Washington, D.C. metro area.</p>
          <p>We support people in four settings — home care, assisted living, long-term care and hospitals — and place Registered Nurses, Licensed Practical Nurses, Certified Nursing Assistants, Geriatric Nursing Assistants, Certified Medication Technicians and Home Health Aides. Every placement is matched to the caregiver's training, credentials and authorized scope, and to the agreed care plan.</p>
        </Reveal>
      </div>
      <div id="how-care-starts" data-testid="how-care-starts">
        <Reveal className="mb-10 space-y-3">
          <Eyebrow>How care starts</Eyebrow>
          <h3 className="font-serif text-3xl sm:text-4xl text-[#154F49]">Four simple steps.</h3>
        </Reveal>
        <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {STEPS.map(({ Icon, t, d }, i) => (
            <Reveal key={t} delay={i * 0.08}>
              <li className="relative h-full p-6 rounded-3xl bg-white border border-[#154F49]/15" data-testid={`care-step-${i + 1}`}>
                <span className="font-serif text-5xl text-[#CDA34F] leading-none">0{i + 1}</span>
                <Icon className="w-6 h-6 text-[#154F49] mt-4" aria-hidden />
                <p className="font-serif text-2xl text-[#154F49] mt-2">{t}</p>
                <p className="text-sm text-[#465F57] mt-2 leading-relaxed">{d}</p>
              </li>
            </Reveal>
          ))}
        </ol>
        <p className="mt-6 text-sm text-[#465F57] max-w-3xl">Service areas for your exact location, office hours, caregiver shift availability, payment options, minimum hours and scheduling are confirmed directly with our team — please call or email us.</p>
      </div>
    </div>
  </section>
);
